import { styled } from 'styled-components'

export const SpinnerBox = styled.div`
  left: 45%;
  position: absolute;
  top: 45%;
`
